import downloadFile from 'js-file-download';

type File = string | ArrayBuffer | ArrayBufferView | Blob;
type FileDownloadProp = {
    data: File;
    filename: string;
    mime?: string;
    bom?: string;
};

export function fileDownload({ data, mime = 'application/pdf', filename }: FileDownloadProp) {
    let _window: any = window;
    if (_window.cordova && data) {
        _window.resolveLocalFileSystemURL(
            _window.cordova.file.cacheDirectory,
            function (dirEntry: any) {
                dirEntry.getFile(
                    filename,
                    { create: true, exclusive: false },
                    function (fileEntry: any) {
                        writeFile(fileEntry, data);
                    },
                    () => {
                        alert('Unable to load file');
                    },
                );
            },
            () => {
                alert('File export error');
            },
        );
        const writeFile = (fileEntry: any, dataObj: File) => {
            fileEntry.createWriter(function (fileWriter: any) {
                fileWriter.onwriteend = function () {
                    console.log('Successful file write...');
                };

                fileWriter.onerror = function (e: any) {
                    alert('Failed file write: ' + e.toString());
                };

                if (!dataObj) {
                    dataObj = new Blob(['Some content'], { type: mime });
                }
                fileWriter.write(dataObj);
                _window.cordova.plugins.fileOpener2.open(fileEntry.nativeURL, mime, {
                    error: function (e: any) {
                        if(e.status == 9) {
                            alert("Supported app not found to open the file")
                        } else {
                            alert('Error status: ' + e.status + ' - Error message: ' + e.message);
                        }
                    },
                    success: function () {
                        console.log('opened successfully');
                    },
                });
            });
        };
        return;
    }
    return downloadFile(data, filename);
}
